// extracted by mini-css-extract-plugin
export default {"subHeader":"styles-module__subHeader__src-labstep-web-core-SubHeader-_u5rKE"};